// Quotation Signed Stage related codes goes here

// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { QuotationSentAcceptorOwnerBtns } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationSentAcceptorOwnerStage(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <QuotationSentAcceptorOwnerBtns {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationSentAcceptorOwnerStage.js